<template>
  <div>
    <v-button
      color="grey"
      size="small"
      icon="arrow-left"
      class="mr-8 mb-4"
      @click="$emit('back-to-kpi-pretable')"
    >
      {{ $t('back') }}
    </v-button>

    <div v-if="loading" class="my-8 text-center">
        <scale-loader></scale-loader>
    </div>
    <div v-if="!loading">
      <div
        v-for="(chart, idx) in chartData"
        :key="(chart.subactivity_id || 'total') + '-' + idx"
        class="chart-container"
      >
        <h4>{{ chart.subactivity }}</h4>
        <canvas :ref="`canvas-${idx}`"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Chart from 'chart.js'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'

export default {
  name: 'KpiCharts',
  components: {ScaleLoader },
  props: {
    groupIds: {
      type: Array,
      required: true
    },
    projectId: {
      type: Number,
      required: true
    },
    objectiveEndDates: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      chartData: [],
      instances: [],
      loading: false
    }
  },
  watch: {
    groupIds: 'fetchChartData',
    projectId: 'fetchChartData',
    objectiveEndDates: {
      handler: 'fetchChartData',
      deep: true
    }
  },
  mounted() {
    this.fetchChartData()
  },
  beforeDestroy() {
    this.instances.forEach(c => c.destroy())
  },
  methods: {
    fetchChartData() {
      // Solo ejecuta si hay datos válidos
      if (!this.projectId || !this.groupIds || !this.groupIds.length) return
      this.loading = true;
      axios.get(`/api/v2/project/${this.projectId}/kpi-charts`, {
        params: {
          groupIds: this.groupIds,
          objectiveEndDates: this.objectiveEndDates
        }
      })
      .then(res => {
        this.chartData = res.data.data
        this.loading = false;
        this.$nextTick(this.renderAllCharts)
      })
      .finally(() => {
        this.loading = false
      })
    },

    renderAllCharts() {
      // destruir instancias previas
      this.instances.forEach(c => c.destroy())
      this.instances = []

      // colores
      const colorMap = {
        'Ejecutado':     '#3e95cd',
        'Prod Sem med':  '#c45850',
        'Ratio Obj Sem': '#e8c44f',
        'Progreso':      '#8e5ea2'
      }

      this.chartData.forEach((chart, idx) => {
        const ctx = this.$refs[`canvas-${idx}`][0].getContext('2d')

        const cfg = {
          type: 'bar',
          data: {
            labels: chart.labels,
            datasets: chart.datasets.map(ds => {
              const base       = colorMap[ds.label] || '#777'
              const isBar      = ds.type === 'bar'
              const isProgress = ds.label === 'Progreso'

              return {
                label: ds.label,
                data: ds.data,
                type: ds.type,
                yAxisID: isProgress ? 'yPercent' : 'y',
                backgroundColor: isBar
                  ? base + '88'
                  : 'transparent',
                borderColor: base,
                borderWidth: 2,
                fill: false,
                pointRadius: isBar ? 0 : 4,
                pointBackgroundColor: !isBar ? base : undefined,
                borderDash: ds.borderDash || []
              }
            })
          },
          options: {
            scales: {
              yAxes: [
                {
                  id: 'y',
                  position: 'left',
                  ticks: { beginAtZero: true }
                },
                {
                  id: 'yPercent',
                  position: 'right',
                  ticks: {
                    beginAtZero: true,
                    max: 100,
                    callback: v => v + '%'
                  },
                  gridLines: { drawOnChartArea: false }
                }
              ],
              xAxes: [
                {
                  ticks: {
                    autoSkip:    false,
                    maxRotation: 45,
                    minRotation: 45
                  }
                }
              ]
            },
            tooltips: { mode: 'index', intersect: false },
            responsive: true,
            maintainAspectRatio: false
          }
        }

        this.instances.push(new Chart(ctx, cfg))
      })
    }
  }
}
</script>

<style scoped>
.chart-container {
  margin-bottom: 2rem;
}
canvas {
  width: 100% !important;
  height: 300px !important;
}
</style>